import styled from 'styled-components';

export const Box = styled.div`
  display: flex;
  justify-content: center;
  height: calc(100vh - 56px);
`;
